<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="准入id" prop="accessManagementId">
          <el-input v-model="dataForm.accessManagementId" placeholder="准入id"></el-input>
      </el-form-item>
          <el-form-item label="公司id" prop="companyId">
          <el-input v-model="dataForm.companyId" placeholder="公司id"></el-input>
      </el-form-item>
          <el-form-item label="签约主体与持牌金融机构（或银行）贷款产品合作协议照片或扫描件" prop="windCooperationAgreements">
          <el-input v-model="dataForm.windCooperationAgreements" placeholder="签约主体与持牌金融机构（或银行）贷款产品合作协议照片或扫描件"></el-input>
      </el-form-item>
          <el-form-item label="签约主体与借款人的贷款委托服务合同1份（已签署并能看到乙方信息及收费标准），借款人信息可脱敏" prop="windContracts">
          <el-input v-model="dataForm.windContracts" placeholder="签约主体与借款人的贷款委托服务合同1份（已签署并能看到乙方信息及收费标准），借款人信息可脱敏"></el-input>
      </el-form-item>
          <el-form-item label=" 准入城市（可多选 以"|"分割）" prop="windCity">
          <el-input v-model="dataForm.windCity" placeholder=" 准入城市（可多选 以"|"分割）"></el-input>
      </el-form-item>
          <el-form-item label="签约主体公司介绍" prop="windCompanyProfile">
          <el-input v-model="dataForm.windCompanyProfile" placeholder="签约主体公司介绍"></el-input>
      </el-form-item>
          <el-form-item label="签约主体的营业执照（加盖公章）" prop="windLicence">
          <el-input v-model="dataForm.windLicence" placeholder="签约主体的营业执照（加盖公章）"></el-input>
      </el-form-item>
          <el-form-item label="签约主体的法人身份证复印件" prop="windLegalId">
          <el-input v-model="dataForm.windLegalId" placeholder="签约主体的法人身份证复印件"></el-input>
      </el-form-item>
          <el-form-item label="办公地址的房屋租赁合同" prop="windOfficeAddress">
          <el-input v-model="dataForm.windOfficeAddress" placeholder="办公地址的房屋租赁合同"></el-input>
      </el-form-item>
          <el-form-item label="真实签约现场视频一份，时长不少于1分钟（借款人脸部可打码）" prop="windLiveVideo">
          <el-input v-model="dataForm.windLiveVideo" placeholder="真实签约现场视频一份，时长不少于1分钟（借款人脸部可打码）"></el-input>
      </el-form-item>
          <el-form-item label="与我司合作协议" prop="contractsCooperationAgreements">
          <el-input v-model="dataForm.contractsCooperationAgreements" placeholder="与我司合作协议"></el-input>
      </el-form-item>
          <el-form-item label="品牌加盟协议" prop="contractsBrandAffiliation">
          <el-input v-model="dataForm.contractsBrandAffiliation" placeholder="品牌加盟协议"></el-input>
      </el-form-item>
          <el-form-item label="品牌使用协议" prop="contractsBrandUse">
          <el-input v-model="dataForm.contractsBrandUse" placeholder="品牌使用协议"></el-input>
      </el-form-item>
          <el-form-item label="技术服务协议" prop="contractsTechnicalServices">
          <el-input v-model="dataForm.contractsTechnicalServices" placeholder="技术服务协议"></el-input>
      </el-form-item>
          <el-form-item label="合规承诺涵" prop="contractsComplianceCommitment">
          <el-input v-model="dataForm.contractsComplianceCommitment" placeholder="合规承诺涵"></el-input>
      </el-form-item>
          <el-form-item label="银树品牌加盟商易拉宝一块并放置于门头照片" prop="doorwayPhoto">
          <el-input v-model="dataForm.doorwayPhoto" placeholder="银树品牌加盟商易拉宝一块并放置于门头照片"></el-input>
      </el-form-item>
          <el-form-item label="是否有效(0无效,1有效)" prop="status">
          <el-input v-model="dataForm.status" placeholder="是否有效(0无效,1有效)"></el-input>
      </el-form-item>
          <el-form-item label="审核状态" prop="checkStatus">
          <el-input v-model="dataForm.checkStatus" placeholder="审核状态"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
          <el-form-item label="申请时间" prop="applicationPeriod">
          <el-input v-model="dataForm.applicationPeriod" placeholder="申请时间"></el-input>
      </el-form-item>
              <el-form-item label="更新者" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新者"></el-input>
      </el-form-item>
          <el-form-item label="更新时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新时间"></el-input>
      </el-form-item>
          <el-form-item label="删除者" prop="deleteBy">
          <el-input v-model="dataForm.deleteBy" placeholder="删除者"></el-input>
      </el-form-item>
          <el-form-item label="删除时间" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除时间"></el-input>
      </el-form-item>
          <el-form-item label="记录产生原因" prop="recordTheCause">
          <el-input v-model="dataForm.recordTheCause" placeholder="记录产生原因"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        accessManagementId: '',
        companyId: '',
        windCooperationAgreements: '',
        windContracts: '',
        windCity: '',
        windCompanyProfile: '',
        windLicence: '',
        windLegalId: '',
        windOfficeAddress: '',
        windLiveVideo: '',
        contractsCooperationAgreements: '',
        contractsBrandAffiliation: '',
        contractsBrandUse: '',
        contractsTechnicalServices: '',
        contractsComplianceCommitment: '',
        doorwayPhoto: '',
        status: '',
        checkStatus: '',
        remark: '',
        applicationPeriod: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteBy: '',
        deleteTime: '',
        recordTheCause: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        accessManagementId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windCooperationAgreements: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windContracts: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windCity: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windCompanyProfile: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windLicence: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windLegalId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windOfficeAddress: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        windLiveVideo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contractsCooperationAgreements: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contractsBrandAffiliation: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contractsBrandUse: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contractsTechnicalServices: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        contractsComplianceCommitment: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        doorwayPhoto: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        checkStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        applicationPeriod: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        recordTheCause: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/accessmanagementlog/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/accessmanagementlog/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
